<script lang="ts">
  import BaseStep from "./BaseStep.svelte";
  import SharedHeading from "../SharedHeading.svelte";
  import { getCopy } from "../../lib/stores/copy";
  import Button from "../Button.svelte";
  import Input from "../Inputs/Input.svelte";
  import { userStore } from "../../lib/stores/user";
  import { setupEntryGate, validateAndContinue, type EntryGateInput } from "../../lib/helpers/steps/entryGate";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import Typography from "../Typography.svelte";
  import CustomHtml from "../CustomHTML.svelte";

  export let currentRoute;
  let isLoading = false;
  let isEntryGateValid = true;

  const onEntryGateContinue = async () => {
    isLoading = true;
    isEntryGateValid = await validateAndContinue();
    isLoading = false;
  };

  const clearErrorMessage = () => {
    isEntryGateValid = true;
  };

  $: copy = $getCopy("entryGate") as Record<string, string>;
  $: entryGateInputs = $getCopy("entry_gate", { basePath: "", defaultReturnValue: [] }) as EntryGateInput[];
  $: setupEntryGate(entryGateInputs);
  $: areAllInputsFilled = entryGateInputs.every((input) => !!$userStore.entryGateData[input.name]);
</script>

<BaseStep {currentRoute}>
  <svelte:fragment slot="content">
    <SharedHeading headerCopy={copy.headerCopy} subHeaderCopy={copy.subHeaderCopy} />
    <div class="mt-4 lg:mt-8 flex flex-col gap-4">
      {#each entryGateInputs as input}
        <Input
          bind:value={$userStore.entryGateData[input.name]}
          type={input.type}
          placeholder={input.label}
          name={input.name}
          onChange={() => clearErrorMessage()} />
      {/each}
    </div>

    <div class="mt-4 lg:mt-10 flex flex-col gap-4">
      {#if !isEntryGateValid}
        <div class="-mt-6 h-3">
          <Typography
            mobile={TypographyType.Body2Regular}
            desktop={TypographyType.Body2Medium}
            --font-color="var(--color-red-50)">
            <span aria-label="error-message">{copy.errorCopy}</span>
          </Typography>
        </div>
      {/if}

      <Button
        class="w-full lg:w-fit"
        primary
        disabled={isLoading || !areAllInputsFilled}
        isBusy={isLoading}
        on:click={onEntryGateContinue}>
        {copy.buttonCopy}
      </Button>
    </div>

    <CustomHtml customHtml={copy.customHtml} />
  </svelte:fragment>
</BaseStep>
